import Product from "./Product";

export default class Organization {
    constructor (json) {
        this.id = 0;
        this.name = "";
        this.site = 0;
        this.products = [];
        this.isDisabled = false;

        if (json)
            mapJsonToOrganization(json, this);
    }
}

const mapJsonToOrganization = (json, organization) => {
    organization.id = json.Id;
    organization.name = json.Name;
    organization.site = json.Site;
    organization.isDisabled = json.IsDisabled;
    organization.isLocked = json.isLocked;
    organization.address = {};
    organization.contact = {};
    organization.parentOrganizationId = json.ParentOrganizationId;
    organization.parentOrganizationName = json.ParentOrganizationName;


    if (json.Products) {
        organization.products = [];
        json.Products.forEach(item => {
            organization.products.push(new Product(item));
        });
    }

};

